<script setup>
import {computed} from 'vue'
import {storeToRefs} from 'pinia';

import AccordionContainer from '../layouts/AccordionContainer.ce.vue';
import AccordionPanel from '../layouts/AccordionPanel.ce.vue';
import PrettyJson from '../layouts/PrettyJson.ce.vue';

import {useChooserFormStore} from '@/store/forms/chooser';
import {usePersonalizedTariffFormStore} from '@/store/forms/personalized_tariffs';
import {useTranslationsStore} from '@/store/translations';
import {useTariffsStore} from '@/store/tariffs';
import {useApiResponsesStore} from '@/store/responses';

const chooserFormStore = useChooserFormStore();
const {debug, formData: chooserFormData} = storeToRefs(chooserFormStore);

const personalizedTariffFormStore = usePersonalizedTariffFormStore();
const {
    formData: tariffFormData,
    yearlyWorkTimeMinusDaysOff,
    livingWages,
    livingWageDifferences,
    socialSecurityTaxes,
    overheadGrandTotal,
} = storeToRefs(personalizedTariffFormStore);

const apiResponsesStore = useApiResponsesStore();
const {countryResponses, regionResponses, occupationResponses} =
    storeToRefs(apiResponsesStore);

const translationStore = useTranslationsStore();
const {translations, context} = storeToRefs(translationStore);

const tariffsStore = useTariffsStore();
const {yearly, hourly, monthly, weekly} = storeToRefs(tariffsStore);

const apiResponses = computed(() => {
    return {
        countryResponses: countryResponses.value,
        regionResponses: regionResponses.value,
        occupationResponses: occupationResponses.value,
    };
});

const chooserFormStoreObj = computed(() => {
    return {
        debug: debug.value,
        chooserFormData: chooserFormData.value,
    }
});

const personalizedTariffsFormStore = computed(() => {
    return {
        tariffFormData: tariffFormData.value,
        yearlyWorkTimeMinusDaysOff: yearlyWorkTimeMinusDaysOff.value,
        livingWages: livingWages.value,
        livingWageDifferences: livingWageDifferences.value,
        socialSecurityTaxes: socialSecurityTaxes.value,
        overheadGrandTotal: overheadGrandTotal.value,
    }
})

const contextObj = computed(() => {
    return {
        context: context.value,
        translations: translations.value,
    }
});

const tariffs = computed(() => {
    return {
        yearly: yearly.value,
        hourly: hourly.value,
        monthly: monthly.value,
        weekly: weekly.value,
    }
});
</script>

<template>
    <link
        rel="stylesheet"
        href="https://cdn.jsdelivr.net/gh/highlightjs/cdn-release@11.8.0/build/styles/default.min.css"
    />
    <AccordionContainer class="mb-8">
        <AccordionPanel :expanded="false">
            <template #title> API responses debugger</template>
            <template #content>
                <PrettyJson :obj="apiResponses"/>
            </template>
        </AccordionPanel>
        <AccordionPanel :expanded="false">
            <template #title> Chooser form store debugger</template>
            <template #content>
                <PrettyJson :obj="chooserFormStoreObj"/>
            </template>
        </AccordionPanel>
        <AccordionPanel :expanded="false">
            <template #title>
                Personalized tariffs form store debugger
            </template>
            <template #content>
                <PrettyJson :obj="personalizedTariffsFormStore"/>
            </template>
        </AccordionPanel>
        <AccordionPanel :expanded="false">
            <template #title> Translation context debugger</template>
            <template #content>
                <PrettyJson :obj="contextObj"/>
            </template>
        </AccordionPanel>
        <AccordionPanel :expanded="false">
            <template #title> Tariff debugger</template>
            <template #content>
                <PrettyJson :obj="tariffs"/>
            </template>
        </AccordionPanel>
    </AccordionContainer>

</template>

<style></style>
